/* unplugin-vue-components disabled */import script from "./AdminLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLayout.vue?vue&type=script&setup=true&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=50670a5e&lang=scss"

const __exports__ = script;

export default __exports__